var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tiptap',{staticClass:"mt-4 custom-border-tiptap",attrs:{"extensions":_vm.extensionTitle,"charCounterCount":false},model:{value:(_vm.modelContent),callback:function ($$v) {_vm.modelContent=$$v},expression:"modelContent"}})}
var staticRenderFns = []

export { render, staticRenderFns }